<template>
  <div>
    <el-row>
      <el-col :span="6">
        <div class="left-box">
          <!-- left 1 -->
          <div class="tip-box-bg">
            <img
              src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701747283627.png"
              alt=""
            />
            <div>数据统计</div>
          </div>
          <div class="left-box-one">
            <div class="left-box-one-left">
              <div class="left-box-one-left-bg">
                <img
                  src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701759854973.png"
                  alt=""
                />
                <div class="left-box-one-left-text">
                  <el-statistic
                    group-separator=","
                    :value="meteorologyDevNum + wormsDevNum + sporeDevNum"
                    title="设备总数(台)"
                    :value-style="valueStyle"
                  ></el-statistic>
                  <!-- <div class="left-box-one-left-text-one">
										设备总数(台)
									</div>
									<div class="left-box-one-left-text-two">
										10000
									</div> -->
                </div>
              </div>
            </div>
            <div>
              <div class="left-box-one-right-one">
                <div style="flex: 1">
                  <el-statistic
                    group-separator=","
                    :value="onDevNum"
                    title=""
                    :value-style="valueStyle2"
                  ></el-statistic>
                  <!-- <div class="left-box-one-right-one-text-one">
										37000
									</div> -->
                  <div style="display: flex; align-items: flex-end">
                    <img
                      src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701758573610.png"
                      alt=""
                    />
                    <div>
                      <div class="left-box-one-right-one-text-two">
                        在线设备
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vertical-line"></div>
                <div style="flex: 1">
                  <el-statistic
                    group-separator=","
                    :value="offDevNum"
                    title=""
                    :value-style="valueStyle2"
                  ></el-statistic>
                  <!-- <div class="left-box-one-right-one-text-one">
										27000
									</div> -->
                  <div style="display: flex; align-items: flex-end">
                    <img
                      src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701758587259.png"
                      alt=""
                    />
                    <div>
                      <div class="left-box-one-right-one-text-two">
                        离线设备
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="left-box-one-right-two">
                <div class="icon-bg-one">
                  <img
                    style=""
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701764689275.png"
                    alt=""
                  />
                </div>
                <div class="icon-bg-two">
                  <div class="left-box-one-right-two-text">
                    <div class="left-box-one-right-two-text-one">在线设备</div>
                    <div class="left-box-one-right-two-text-two">
                      <!-- 37000/100000 -->
                      {{ onDevNum }}/{{
                        meteorologyDevNum + wormsDevNum + sporeDevNum
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="left-box-one-right-two">
                <div class="icon-bg-one">
                  <img
                    style=""
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701764687128.png"
                    alt=""
                  />
                </div>
                <div class="icon-bg-two">
                  <div class="left-box-one-right-two-text">
                    <div class="left-box-one-right-two-text-one">离线设备</div>
                    <div class="left-box-one-right-two-text-two">
                      {{ offDevNum }}/{{
                        meteorologyDevNum + wormsDevNum + sporeDevNum
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- left 1 end -->
          <!-- left 2 -->
          <div class="tip-box-bg">
            <img
              src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701747283627.png"
              alt=""
            />
            <div>设备列表</div>
          </div>
          <div class="left-box-two" style="width: 90%">
            <div @click="chooserCurrent(0)" class="left-box-two-item">
              <img
                src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701830214090.png"
                alt=""
              />
              <div style="margin-left: 10px">
                <div class="left-box-two-item-text-one">
                  气象设备
                  <img
                    v-show="current == 0"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701854358966.png"
                    alt=""
                  />
                </div>
                <el-statistic
                  group-separator=","
                  :value="meteorologyDevNum"
                  title=""
                  :value-style="valueStyle3"
                ></el-statistic>
                <!-- <div class="left-box-two-item-text-two">
									6000
								</div> -->
              </div>
            </div>
            <div class="vertical-line"></div>
            <div @click="chooserCurrent(1)" class="left-box-two-item">
              <img
                src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701830230111.png"
                alt=""
              />
              <div style="margin-left: 10px">
                <div class="left-box-two-item-text-one">
                  墒情设备
                  <img
                    v-show="current == 1"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701854358966.png"
                    alt=""
                  />
                </div>
                <el-statistic
                  group-separator=","
                  :value="soilDevNum"
                  title=""
                  :value-style="valueStyle3"
                ></el-statistic>
              </div>
            </div>
            <div class="vertical-line"></div>
            <div @click="chooserCurrent(2)" class="left-box-two-item">
              <img
                src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701830251181.png"
                alt=""
              />
              <div style="margin-left: 10px">
                <div class="left-box-two-item-text-one">
                  虫情设备
                  <img
                    v-show="current == 2"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701854358966.png"
                    alt=""
                  />
                </div>
                <el-statistic
                  group-separator=","
                  :value="wormsDevNum"
                  title=""
                  :value-style="valueStyle3"
                ></el-statistic>
              </div>
            </div>
          </div>
          <div class="left-box-two" style="width: 60%">
            <div @click="chooserCurrent(3)" class="left-box-two-item">
              <img
                src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701830271584.png"
                alt=""
              />
              <div style="margin-left: 10px">
                <div class="left-box-two-item-text-one">
                  孢子设备
                  <img
                    v-show="current == 3"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701854358966.png"
                    alt=""
                  />
                </div>
                <el-statistic
                  group-separator=","
                  :value="sporeDevNum"
                  title=""
                  :value-style="valueStyle3"
                ></el-statistic>
              </div>
            </div>
            <div class="vertical-line"></div>
            <div @click="chooserCurrent(4)" class="left-box-two-item">
              <img
                src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701830723810.png"
                alt=""
              />
              <div style="margin-left: 10px">
                <div class="left-box-two-item-text-one">
                  苗情设备
                  <img
                    v-show="current == 4"
                    src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701854358966.png"
                    alt=""
                  />
                </div>
                <el-statistic
                  group-separator=","
                  :value="miaoQingDevNum"
                  title=""
                  :value-style="valueStyle3"
                ></el-statistic>
              </div>
            </div>
            <div
              class=""
              style="
                width: 1px;
                height: 50px;
                background: #686d8700;
                margin: 0 0 0 12px;
              "
            ></div>
          </div>
          <!-- left 2 end -->
          <!-- left 3 -->
          <div class="left-box-three">
            <div class="left-box-three-head">
              <div style="width: 30%">设备名称</div>
              <div style="width: 25%">所属园区</div>
              <div style="width: 25%">设备状态</div>
              <div style="width: 20%">详情</div>
            </div>
            <div class="left-box-three-body">
              <div
                @click="chooserTable(index)"
                class="left-box-three-item"
                v-for="(item, index) in tableData"
                :key="index"
              >
                <div
                  class="item-name"
                  :style="
                    tableIndex == index
                      ? 'background: rgba(254, 52, 24, 0.3);'
                      : index % 2
                      ? 'background: rgba(70, 70, 70, 0.35);'
                      : ''
                  "
                >
                  <el-tooltip :content="item.deviceName" placement="top">
                    <div class="text-overflow">
                      {{ item.deviceName }}
                    </div>
                  </el-tooltip>
                </div>
                <div
                  class="item-address"
                  :style="
                    tableIndex == index
                      ? 'background: rgba(254, 52, 24, 0.3);'
                      : index % 2
                      ? 'background: rgba(70, 70, 70, 0.35);'
                      : ''
                  "
                >
                  <el-tooltip :content="item.group.groupName" placement="top">
                    <div class="text-overflow">
                      {{ item.group.groupName }}
                    </div>
                  </el-tooltip>
                </div>
                <div
                  class="item-state"
                  :style="
                    tableIndex == index
                      ? 'background: rgba(254, 52, 24, 0.3);'
                      : index % 2
                      ? 'background: rgba(70, 70, 70, 0.35);'
                      : ''
                  "
                >
                  {{
                    item.status == "online"
                      ? "在线"
                      : item.status == "offline"
                      ? "离线"
                      : "报警"
                  }}
                </div>
                <div
                  class="item-detail"
                  :style="
                    tableIndex == index
                      ? 'background: rgba(255, 72, 61, 1);'
                      : index % 2
                      ? 'background: rgba(70, 70, 70, 0.35);'
                      : ''
                  "
                >
                  {{ item.status == "offline" ? "---" : "详情" }}
                </div>
              </div>
              <div v-if="tableData.length == 0">
                <el-empty
                  :image-size="75"
                  description="暂无设备"
                  image="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705376475598.png"
                ></el-empty>
              </div>
            </div>
          </div>
          <!-- left 3 end -->
        </div>
      </el-col>
      <el-col :span="18">
        <!-- 气象 meteorologyDeviceList -->
        <Meteorology
          v-if="current == 0 && meteorologyDeviceList.length != 0"
          key="0"
          :devItem="devItem"
        ></Meteorology>
        <!-- 墒情 soilDeviceList -->
        <Soil
          v-if="current == 1 && soilDeviceList.length != 0"
          key="0"
          :devItem="devItem"
        ></Soil>
        <!-- 虫情 wormsDeviceList -->
        <Worms
          v-if="current == 2 && wormsDeviceList.length != 0"
          key="2"
          :devItem="devItem"
        ></Worms>
        <!-- 孢子 sporeDeviceList -->
        <Spore
          v-if="current == 3 && sporeDeviceList.length != 0"
          key="3"
          :devItem="devItem"
        ></Spore>
        <!-- 苗情 miaoQingDeviceList -->
        <MiaoQing
          v-if="current == 4 && miaoQingDeviceList.length != 0"
          key="4"
        ></MiaoQing>
      </el-col>
      <!-- <el-col :span="6">
				<div style="width: 100%;height: 100%;border: 1px solid orange;"></div>
			</el-col> -->
    </el-row>
  </div>
</template>

<script>
import Meteorology from "../../fiveEmotionsContent/meteorology/meteorology.vue";
import Worms from "../../fiveEmotionsContent/worms/worms.vue";
import MiaoQing from "../../fiveEmotionsContent/miaoQing/miaoQing.vue";
import Spore from "../../fiveEmotionsContent/spore/spore.vue";
import Soil from "../../fiveEmotionsContent/soil/soil.vue";
export default {
  name: "app",
  components: {
    Meteorology,
    Worms,
    MiaoQing,
    Spore,
    Soil,
  },
  data() {
    return {
      devItem: {},
      meteorologyDevNum: 0,
      soilDevNum: 0,
      wormsDevNum: 0,
      sporeDevNum: 0,
      miaoQingDevNum: 0,
      onDevNum: 0,
      offDevNum: 0,
      valueStyle: {
        color: "#fff",
        fontSize: "26px",
        fontWeight: "bold",
        borderBottom: "1px solid #c8ced1",
      },
      valueStyle2: {
        fontSize: "24px",
        fontWeight: "normal",
        color: "#fff",
        marginBottom: "8px",
      },
      current: 0,
      valueStyle3: {
        fontSize: "18px",
        fontWeight: "normal",
        color: "#fff",
        marginTop: "8px",
      },
      tableData: [], //页面展示list
      meteorologyDeviceList: [], //气象
      meteorologyDeviceListShow: [],
      soilDeviceList: [], //墒情
      soilDeviceListShow: [],
      wormsDeviceList: [], //虫情
      sporeDeviceList: [], //孢子
      miaoQingDeviceList: [], //苗情
      tableIndex: 0,
      userInfo: {},
    };
  },
  mounted() {
    // 从本地缓存中获取数据
    let userInfo = localStorage.getItem("user_info");
    // 将获取到的JSON字符串转换回对象
    this.userInfo = JSON.parse(userInfo);
    this.getMeteorologyList("met"); //气象
    this.getMeteorologyList("soil"); //墒情
    this.getMeteorologyList("wormFlagship"); //虫情
    this.getMeteorologyList("spore"); //孢子
  },
  methods: {
    //切换设备
    chooserCurrent(e) {
      if (e == 0) {
        //气象
        if (this.meteorologyDeviceList.length == 0) {
          this.getMeteorologyList("met");
        } else {
          this.tableData = this.meteorologyDeviceList;
        }
        console.log("切换设备---气象");
      } else if (e == 1) {
        //墒情
        console.log("切换设备---墒情");
        // this.tableData = this.soilDeviceList;
        if (this.soilDeviceList.length == 0) {
          this.getMeteorologyList("soil");
        } else {
          this.tableData = this.soilDeviceList;
        }
      } else if (e == 2) {
        //虫情
        if (this.wormsDeviceList.length == 0) {
          this.getMeteorologyList("wormFlagship");
        } else {
          this.tableData = this.wormsDeviceList;
        }
        console.log("切换设备---虫情");
      } else if (e == 3) {
        //孢子
        if (this.sporeDeviceList.length == 0) {
          this.getMeteorologyList("spore");
        } else {
          this.tableData = this.sporeDeviceList;
        }
        console.log("切换设备---孢子");
      } else if (e == 4) {
        //苗情
        console.log("切换设备---苗情");
        this.tableData = this.miaoQingDeviceList;
      }
      this.current = e;
      this.chooserTable(0);
    },
    chooserTable(index) {
      if (this.tableData[index].status == "offline") {
        this.$message.error("当前设备不在线");
      }
      console.log("切换园区---this.tableData==========", this.tableData);
      console.log(
        "切换园区---this.tableData[index]==========",
        this.tableData[index].deviceName
      );

      this.tableIndex = index;
      this.devItem = this.tableData[index];
    },
    getMeteorologyList(type) {
      let httpData = {
        deptId: this.userInfo.deptId, //101
        groupId: "",
        deviceType: type,
      };

      this.$axios
        .get("/FourEmotions/GetUserDevice", {
          params: httpData,
        })
        .then((res) => {
          console.log("getMeteorologyList-res===", res);
          let data = res.data;
          if (data.length > 0) {
            for (let i in data) {
              data[i].status = "";
              data[i].devData = [];
              this.getMeteorologyDataDetail(
                data[i].deviceAddr,
                data[i],
                i,
                type
              );

              // if (type == 'met') { //气象
              // 	this.meteorologyDeviceList.push(data[i]);
              // 	this.meteorologyDeviceListShow = this.meteorologyDeviceList;
              // }
              // if (type == 'wormFlagship') { //虫情
              // 	this.wormsDeviceList.push(data[i]);
              // }
              // if (type == 'spore') { //孢子
              // 	this.sporeDeviceList.push(data[i]);
              // }
              // this.tableData = this.meteorologyDeviceListShow;
              // if (i == 0 && type == 'met') {
              // 	this.chooserTable(0)
              // }
            }

            if (type == "met") {
              //气象
              this.meteorologyDevNum = data.length;
            }
            if (type == "soil") {
              //墒情
              this.soilDevNum = data.length;
            }
            if (type == "wormFlagship") {
              //虫情
              this.wormsDevNum = data.length;
            }
            if (type == "spore") {
              //孢子
              this.sporeDevNum = data.length;
            }
          }
        })
        .catch((error) => {
          console.log("getMeteorologyList-error===", error);
        });
    },
    getMeteorologyDataDetail(deviceAddr, ress, i, type) {
      let httpData = {
        deptId: this.userInfo.deptId, //101
        deviceAddrs: deviceAddr, //'40160490'
      };
      this.$axios
        .get("/FourEmotions/getRealTimeData", {
          params: httpData,
        })
        .then((res) => {
          // console.log('getMeteorologyDataDetail-res===', res);
          ress.status = res.data.length != 0 ? res.data[0].status : "offline";
          ress.devData = res.data;
          if (ress.status == "offline") {
            this.offDevNum++;
          } else {
            this.onDevNum++;
          }

          if (type == "met") {
            //气象
            this.meteorologyDeviceList.push(ress);
            this.meteorologyDeviceListShow = this.meteorologyDeviceList;
            this.tableData = this.meteorologyDeviceListShow;
          }
          if (type == "soil") {
            //墒情
            this.soilDeviceList.push(ress);
            this.soilDeviceListShow = this.soilDeviceList;
            this.tableData = this.soilDeviceListShow;
          }
          if (type == "wormFlagship") {
            //虫情
            this.wormsDeviceList.push(ress);
          }
          if (type == "spore") {
            //孢子
            this.sporeDeviceList.push(ress);
          }
          if (i == 0 && type == "met") {
            this.chooserTable(0);
          }
        })
        .catch((error) => {
          console.log("getRealTimeData-error===", error);
        });
    },
  },
};
</script>

<style scoped>
.left-box {
  width: 100%;
  height: 100%;
  cursor: default;
  /* border: 1px solid red; */
}

.tip-box-bg {
  width: 90%;
  height: 44px;
  background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701757063603.png)
    no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
}

.tip-box-bg img {
  width: 20px;
  height: 20px;
  margin-right: 7px;
}

.tip-box-bg div {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}

.left-box-one {
  width: 90%;
  height: 210px;
  background: rgba(216, 216, 216, 0.01);
  display: flex;
  align-items: center;
}

.left-box-one-left {
  width: 203px;
  height: 209px;
  display: flex;
}

.left-box-one-left-bg {
  width: 163.17px;
  height: 165.79px;
  position: relative;
  display: flex;
  margin: auto;
  background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701758961045.png)
    no-repeat;
  background-size: 100% 100%;
}

.left-box-one-left-bg img {
  width: 51px;
  height: 50.29px;
  position: absolute;
  left: -10px;
  top: -10px;
}

.left-box-one-left-text {
  margin: auto;
  text-align: center;
  font-family: AlibabaPuHuiTi;
  color: #ffffff;
}

.left-box-one-left-text-one {
  font-size: 10px;
  font-weight: normal;
}

.left-box-one-left-text-two {
  font-size: 26px;
  font-weight: bold;
  border-bottom: 1px solid #c8ced1;
  margin-top: 11px;
}

.left-box-one-right-one {
  width: 206px;
  height: 72px;
  display: flex;
  align-items: center;
  border-top: 1px solid #6a8b9d;
  border-bottom: 1px solid #6a8b9d;
}

.vertical-line {
  width: 1px;
  height: 50px;
  background: #686d87;
  margin: 0 12px 0 12px;
}

.left-box-one-right-one img {
  width: 6px;
  height: 24px;
  margin-right: 6px;
}

.left-box-one-right-one-text-one {
  font-family: FZChaoCuHei-M10S;
  font-size: 24px;
  font-weight: normal;
  margin-bottom: 8px;
}

.left-box-one-right-one-text-two {
  font-family: AlibabaPuHuiTi;
  font-size: 12px;
  font-weight: normal;
}

.left-box-one-right-two {
  display: flex;
  margin-top: 6px;
}

.icon-bg-one {
  width: 36px;
  height: 36px;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-bg-one img {
  width: 28px;
  height: 28px;
}

.icon-bg-two {
  width: 169px;
  height: 36px;
  background: rgba(0, 0, 0, 0.4);
  margin-left: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-box-one-right-two-text {
  display: flex;
  margin: auto;
  font-family: AlibabaPuHuiTi;
  font-size: 12px;
}

.left-box-one-right-two-text-one {
  font-weight: normal;
}

.left-box-one-right-two-text-two {
  font-weight: bold;
  margin-left: 7px;
}

.left-box-two {
  height: 60px;
  margin-top: 16px;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid rgba(103, 122, 137, 0.6);
  border-bottom: 1px solid rgba(103, 122, 137, 0.6);
}

.left-box-two-item {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-box-two-item img {
  width: 36px;
  height: 36px;
}

.left-box-two-item-text-one {
  font-family: AlibabaPuHuiTi;
  font-size: 10px;
  font-weight: normal;
}

.left-box-two-item-text-one img {
  width: 11px;
  height: 8px;
}

.left-box-two-item-text-two {
  font-family: FZChaoCuHei-M10S;
  font-size: 18px;
  font-weight: normal;
  margin-top: 7px;
}

.title {
  padding-left: 0px;
  font-size: 10px;
  font-weight: normal;
  color: #fff;
}

.left-box-three {
  font-family: AlibabaPuHuiTi;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-weight: normal;
}

.left-box-three-head {
  width: 90%;
  height: 32px;
  margin-top: 16px;
  background: rgba(70, 70, 70, 0.35);
  display: flex;
  align-items: center;
  text-align: center;
}

.left-box-three-body {
  width: 90%;
  height: 440px;
  overflow: scroll;
}

.left-box-three-body::-webkit-scrollbar {
  display: none;
}

.left-box-three-item {
  width: 100%;
  height: 32px;
  display: flex;
  text-align: center;
}

.text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.item-name {
  width: 30%;
  height: 32px;
  line-height: 32px;
}

.item-address {
  width: 25%;
  height: 32px;
  line-height: 32px;
}

.item-state {
  width: 25%;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-detail {
  width: 20%;
  margin-left: 15px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
